import { BASE_URL } from '../../../../../utils/config.base-url'

export const WORKING_EQUIPMENT_PREFIX_URL = '/working-equipment'
export const URL_ENDPOINT_WORKING_EQUIPMENT = `${BASE_URL}/working-equipment`
